import { useLocation, useParams } from "react-router";
import { ScrollableMenu } from "../../../components/scrollableMenu/scrollableMenu";
import { CheckListItem } from "./checkListItem";
import { useEffect, useMemo, useState } from "react";
import { CoffeCupIcon } from "../../../assets/icons";
import { Button } from "../../../components/button/button";
import { AdminHeader } from "../../../components/adminHeader/adminHeader";
import { useAnimatedNavigate } from "../../../hooks/useAnimatedNavigate";
import AdminAPI from "../../../api/AdminAPI";
import qs from "qs";

import styles from "./workerCheckList.module.css";
import CheckListAPI from "../../../api/CheckListAPI";
import { PageLoader } from "../../../components/loader/pageLoader";
import { Separator } from "../../../components/separator/separator";

import { Text } from "../../../components/text/text";

export const WorkerCheckListPage = () => {
    const { userId, cafeId } = useParams();
    const { search } = useLocation();
    const searchParams = qs.parse(search.replace("?", ""));

    const [pageLoading, setPageLoading] = useState(true);
    const [tabId, setTabId] = useState(null);
    const [checklistCategories, setChecklistCategories] = useState([]);
    useEffect(() => {
        CheckListAPI
            .fetchChecklistCategories(cafeId)
            .then((res) => {
                setChecklistCategories(res);
            })
            .catch(console.error)
            .finally(() => setPageLoading(false));
    }, [cafeId]);

    useEffect(() => {
        if (!tabId) {
            if (searchParams.initialTab) {
                setTabId(+searchParams.initialTab);
            } else if (checklistCategories[0]) {
                setTabId(+checklistCategories[0].id);
            }
        }
    }, [searchParams, checklistCategories, tabId]);

    const tab = useMemo(() => checklistCategories.find(el => el.id === tabId), [checklistCategories, tabId]);

    const [items, setItems] = useState([]);
    const tabItems = useMemo(() => items.filter(el => el.categoryName === tab?.text), [items, tab?.text]);

    const [checkListId, setChecklistId] = useState(null);
    const [isDailyTasks, setIsDailyTasks] = useState((searchParams.initialDaily !== undefined) ? searchParams.initialDaily === "true" : true);

    useEffect(() => {
        AdminAPI
            .fetchChecklistID(userId)
            .then(res => setChecklistId(res.id))
            .catch(console.error);
    }, [userId]);

    useEffect(() => {
        if (isDailyTasks) {
            if (checkListId === null) return;
            AdminAPI
                .fetchDailyTasks(userId, checkListId)
                .then(data => setItems(data))
                .catch(console.error);
        } else {
            AdminAPI
                .fetchReccurentTasks(userId)
                .then(data => setItems(data))
                .catch(console.error);
        }

    }, [checkListId, userId, isDailyTasks]);

    const navigate = useAnimatedNavigate();

    const onDeleteTask = (id) => {
        if (isDailyTasks) {
            AdminAPI
                .deleteDailyTask(id)
                .then(() => {
                    setItems(prev => prev.filter(el => el.id !== id));
                })
                .catch(console.error);
        } else {
            AdminAPI
                .deleteReccurentTask(id)
                .then(() => {
                    setItems(prev => prev.filter(el => el.id !== id));
                })
                .catch(console.error);
        }
    }

    useEffect(() => {
        setItems([])
    }, [isDailyTasks]);

    if (pageLoading) {
        return <PageLoader />
    }

    return (
        <>
            <AdminHeader title="Задачи" userId={userId} />

            <Text as="div" variant="body" className="page_description" >
                Установите план для сотрудника, он отобразится в его профиле.
            </Text>

            <div className={styles.view_type_selector}>
                <Button
                    view="thin"
                    type={isDailyTasks ? "primary" : "secondary"}
                    text="Дневные"
                    onClick={() => setIsDailyTasks(true)}
                />

                <Button
                    view="thin"
                    type={!isDailyTasks ? "primary" : "secondary"}
                    text="Повторяющиеся"
                    onClick={() => setIsDailyTasks(false)}
                />
            </div>

            <ScrollableMenu
                buttons={checklistCategories}
                current={tabId}
                setCurrent={setTabId}
            />

            {
                tabItems.length === 0 &&
                <div className={styles.no_elements_placeholder}>
                    <CoffeCupIcon className={styles.no_elements_icon} />
                    <Text as="div" variant="body" className={styles.no_elements_text} size={16} weight={700}>
                        Задач данной категории пока что нет.
                    </Text>
                </div>
            }

            {
                tabItems.length > 0 &&
                <div className={styles.check_list_items}>
                    {
                        tabItems.map((item) => (
                            <CheckListItem key={item.id} data={item} onDeleteTask={onDeleteTask} isDailyTasks={isDailyTasks} tabId={tabId} />
                        ))
                    }
                </div>
            }

            <Separator />

            <Button
                fixed
                type="primary"
                text="Поставить задачу"
                onClick={() => navigate(`add?initialTab=${tabId}`)}
            />
        </>
    )
}
